import { Component, OnInit } from '@angular/core';
import { UserService} from "../../Services/Users.service";
import {AuthService} from "../../Services/AuthGard.service";
import {GlobalService} from '../../Services/global.service';
declare var $;
import * as CryptoJS from 'crypto-js';
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-community-user',
  templateUrl: './community-user.component.html',
  styleUrls: ['./community-user.component.css'],
  providers: [UserService]
})
export class CommunityUserComponent implements OnInit {
  question:string;
  answer:string;
  passwordChange = false;
  confpassword: string;
  oldpassword: string ;
  newpassword: string;
  Invalidpassword = false;
  securityQuestions : Array<any> = [];
  statusCode;
  communityLogoShow: boolean;
  passwordType: boolean = false;
  passwordNewType: boolean = false;
  passwordConfirmType: boolean = false;
  que_id: string='';
  nonAsciiOccurenece: boolean;
  nonAsciiOccurenece1: boolean;

  constructor(private userService: UserService, private authService: AuthService,private globalService: GlobalService, private translate: TranslateService) {
    let lang_name = localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English';
    this.translate.use(lang_name);
    this.translate.reloadLang(lang_name);
  }

  ngOnInit() {
    let lang_id = this.globalService.getLangId();
    this.userService.getSecurityQuestions(lang_id)
      .subscribe(questions =>{
        if(questions.success){
          this.securityQuestions = questions.data;
          $("#preloader").css('display','none');
        }
      });
  }

  updateCommunityUser(){
    let current_user = JSON.parse(localStorage.getItem('currentUser'));
    // new changes 20-oct
    this.securityQuestions.forEach(ele=>{
      if( ele.que===this.question){
     console.log(ele.que) ;
     this.que_id=ele.que_id;
      }
    }
    );
    console.log('this.que_id==>',this.que_id);
    let obj = {
      user_id: current_user.user.userid,
      question: this.question,
      // new changes 20-oct
      question_id:this.que_id,
      answer: this.answer,
      passchange: false,
      updated_by : current_user.user.username
    };
    console.log('obj==>',obj);
    var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(obj), '#Alignor Credentials#').toString();
    let authentication = {
      authentication: ciphertext
    }
    this.userService.updateCommunityUsers(authentication).subscribe(res => {
      this.passwordChange = true;
    });
  }

  changeUserPassword(passChangeForm){
    let current_user = JSON.parse(localStorage.getItem('currentUser'));
    let obj = {
      user_id: current_user.user.userid,
      oldpassword: this.oldpassword,
      newpassword: this.newpassword,
      confpassword: this.confpassword,
      passchange: true,
      updated_by : current_user.user.username
    };
      this.Invalidpassword = false;
    this.statusCode = "";

    var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(obj), '#Alignor Credentials#').toString();
    let authentication = {
      authentication: ciphertext
    }

      this.userService.updateCommunityUsers(authentication).subscribe(res => {
        this.statusCode = res.statusCode;
        if(res.success){
          $('#successModal').modal('show');
        }
      });
  }

  cancelChangePassword(passChangeForm){
    passChangeForm.reset();
    this.authService.logout().subscribe( log =>{
      if(log.success){
        let lang_name = localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English';
        this.translate.reloadLang(lang_name);
        localStorage.clear();
      }
    });
  }

  closeSuccesssModal() {
    $('#successModal').modal('hide');
    this.authService.logout().subscribe( log =>{
      if(log.success){
        let lang_name = localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English';
        this.translate.reloadLang(lang_name);
        localStorage.clear();
      }
    });
  }

  changePasswordType(type) {
    
    if (type == 'old') {
      this.passwordType = !this.passwordType;
    } else if (type == 'new') {
      this.passwordNewType = !this.passwordNewType;
    } else if (type == 'confirm') {
      this.passwordConfirmType = !this.passwordConfirmType;
    }
  }

  checkForNonAscii()
  {   
    var ascii = /[^\u0000-\u007f]/;
    console.log("event is here",this.newpassword);
    if ( !ascii.test( this.newpassword ) ) {  
      this.nonAsciiOccurenece = false;
      console.log(this.nonAsciiOccurenece);
    }else{
      this.nonAsciiOccurenece = true;
      console.log(this.nonAsciiOccurenece);
      // alert("non ascii is here");
    } 
  }
  checkForNonAsciicpass(){
    var ascii = /[^\u0000-\u007f]/;
    console.log("event is here",this.confpassword);
    if ( !ascii.test( this.confpassword ) ) {  
      this.nonAsciiOccurenece1 = false;
      console.log(this.nonAsciiOccurenece);
    }else{
      this.nonAsciiOccurenece1 = true;
      console.log(this.nonAsciiOccurenece);
      // alert("non ascii is here");
    } 
  }
}



// WEBPACK FOOTER //
// ./src/app/Screens/community-user/community-user.component.ts